import { Session } from "@chromia/ft4";

import { ChrDeposit } from "../../classes/ChrDeposit";
import { iChrItem, iChrLaunch, iChrPeriod, iTypedGtxClient, tDiscountPercent } from "../../interfaces";

export enum eChromiaActionTypes{
	CLEAR_STATE = 'CHR/CLEAR_STATE',
	SET_SESSION = 'CHR/SET_SESSION',
	SET_CHR_CLIENT_ADDR = 'CHR/SET_CHR_CLIENT_ADDR',
	SET_GTX_CLIENT = 'CHR/SET_GTX_CLIENT',
	SET_DEPOSITS = 'CHR/SET_DEPOSITS',
	SET_LAUNCHES = 'CHR/SET_LAUNCHES',
	SET_PERIODS = 'CHR/SET_PERIODS',
	SET_IS_CHR_REGISTERED = 'CHR/SET_IS_CHR_REGISTERED',
	SET_ITEM = 'CHR/SET_ITEM',
	SET_END_TIME = 'CHR/SET_END_TIME',
}

export type tChromiaAction =
	iClearStateAction |
	iSetSessionAction |
	iSetChrClientAddrAction |
	iSetGtxClientAction |
	iSetDepositsAction |
	iSetLaunchesAction |
	iSetPeriodsAction  |
	iSetIsChrRegisteredAction |
	iSetItemAction |
	iSetEndTimeAction
;

interface iClearStateAction {
	type: eChromiaActionTypes.CLEAR_STATE
}

interface iSetSessionAction {
	type: eChromiaActionTypes.SET_SESSION,
	payload: Session
}

interface iSetChrClientAddrAction {
	type: eChromiaActionTypes.SET_CHR_CLIENT_ADDR,
	payload: string
}

interface iSetGtxClientAction {
	type: eChromiaActionTypes.SET_GTX_CLIENT,
	payload: iTypedGtxClient
}

interface iSetDepositsAction {
	type: eChromiaActionTypes.SET_DEPOSITS,
	payload: {
		percent: tDiscountPercent,
		deposits: ChrDeposit[]
	}
}

interface iSetLaunchesAction {
	type: eChromiaActionTypes.SET_LAUNCHES,
	payload: iChrLaunch[]
}

interface iSetPeriodsAction {
	type: eChromiaActionTypes.SET_PERIODS,
	payload: iChrPeriod[]
}

interface iSetIsChrRegisteredAction {
	type: eChromiaActionTypes.SET_IS_CHR_REGISTERED,
	payload: boolean
}

interface iSetItemAction {
	type: eChromiaActionTypes.SET_ITEM,
	payload: {
		percent: tDiscountPercent,
		item: iChrItem
	}
}

interface iSetEndTimeAction {
	type: eChromiaActionTypes.SET_END_TIME,
	payload: {
		percent: tDiscountPercent,
		endTime: number
	}
}